module.exports = __webpack_public_path__ + "distribution/img/kong1.bfbed4b4.png";